import React from "react";

// MUI Imports
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const CustomerReportDownloadsHeader = () => {
  const headCells = [
    { id: "Billing Start Date", numeric: false, label: "Billing Start Date" },
    { id: "Billing End Date", numeric: false, label: "Billing End Date" },
    { id: "People Threshold", numeric: false, label: "People Threshold" },
    { id: "Property Threshold", numeric: false, label: "Property Threshold" },
    { id: "Phone Threshold", numeric: false, label: "Phone Threshold" },
    { id: "Social Threshold", numeric: false, label: "Social Threshold" },
    { id: "Auto Threshold", numeric: false, label: "Auto Threshold" }
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map(({label, id}) => (
          <TableCell
            key={id}
            className="headerText"
            align="center"
            padding="normal"
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CustomerReportDownloadsHeader;
